/* eslint-disable*/
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { API_URL } from "../../config";
import { showToast } from "../../components/toast";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import LoadingSpinner from "../../components/LoadingSpinner";


const SendWhatsappBulk = () => {
  const [templateList, setTemplateList] = useState([]);
  const [leadSourceList, setLeadSourceList] = useState([]);
  const [leadStatusList, setLeadStatusList] = useState([]);
  const [sendWhatsapp, setSendWhatsapp] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 100,
    totalRecords: 0,
  });
  const [formData, setFormData] = useState({
    templateid: "",
    leadsource: "",
    leadstatus: "",
    daterange: [null, null],
  });
  const [startDate, endDate] = formData.daterange;

  const navigate = useNavigate();

  // Fetch initial data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("authToken");

        const response = await axios.get(`${API_URL}socialsharing/WhatsApp`, {
          params: {
            page: pagination.page,
            limit: pagination.limit,
          },
          headers: { Authorization: `Bearer ${token}` },
        });

        const data = response.data;

        const templates = Object.entries(data.templateList).map(
          ([id, name]) => ({
            id: parseInt(id),
            name,
          })
        );
        setTemplateList(templates);

        const leadSources = Object.entries(data.leadSourceList).map(
          ([id, name]) => ({
            id,
            name,
          })
        );
        setLeadSourceList(leadSources);

        const leadStatuses = Object.entries(data.leadStatusList).map(
          ([id, name]) => ({
            id,
            name,
          })
        );
        setLeadStatusList(leadStatuses);

        setSendWhatsapp(data.sendWhatsapp || []);
        setPagination((prev) => ({
          ...prev,
          totalRecords: data.totalRecords,
        }));

        setLoading(false);
      } catch (err) {
        console.error("Error fetching data:", err);
        showToast.error("Failed to load data. Please try again.");
        setLoading(false);
      }
    };

    fetchData();
  }, [pagination.page, pagination.limit]);

  useEffect(() => {
    const handleClearEvent = () => {
      setFormData({
        templateid: "",
        leadsource: "",
        leadstatus: "",
        daterange: [null, null],
      });
    };

    window.addEventListener('clearWhatsappFiltersEvent', handleClearEvent);
    return () => {
      window.removeEventListener('clearWhatsappFiltersEvent', handleClearEvent);
    };
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleDateChange = (dates) => {
    setFormData({
      ...formData,
      daterange: dates,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitLoading(true);
    try {
      const token = localStorage.getItem("authToken");

      const formattedData = {
        ...formData,
        daterange:
          formData.daterange[0] && formData.daterange[1]
            ? `${formatDate(formData.daterange[0])} - ${formatDate(
              formData.daterange[1]
            )}`
            : "",
      };

      await axios.post(`${API_URL}socialsharing/send-whatsapp`, formattedData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      showToast.success("WhatsApp messages sent successfully!");

      const refreshRes = await axios.get(`${API_URL}socialsharing/WhatsApp`, {
        params: {
          page: pagination.page,
          limit: pagination.limit,
        },
        headers: { Authorization: `Bearer ${token}` },
      });
      setSendWhatsapp(refreshRes.data.sendWhatsapp || []);
      setPagination((prev) => ({
        ...prev,
        totalRecords: refreshRes.data.totalRecords,
      }));
      setFormData({
        templateid: "",
        leadsource: "",
        leadstatus: "",
        daterange: [null, null],
      });
    } catch (err) {
      console.error("Error sending WhatsApp messages:", err);
      showToast.error(
        err.response?.data?.message || "Failed to send WhatsApp messages"
      );
    } finally {
      setSubmitLoading(false);
    }
  };

  const formatDate = (date) => {
    if (!date) return "";
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const parseSendToCriteria = (sendTo) => {
    try {
      const criteria = JSON.parse(sendTo);
      let result = [];

      if (criteria.leadsource) {
        result.push(`Lead Source: ${criteria.leadsource}`);
      }
      if (criteria.leadstatus) {
        result.push(`Lead Status: ${criteria.leadstatus}`);
      }
      if (criteria.daterange) {
        result.push(`Date Range: ${criteria.daterange}`);
      }

      return result.join(", ");
    } catch (e) {
      return sendTo;
    }
  };

  const handlePageChange = (newPage) => {
    if (
      newPage >= 1 &&
      newPage <= Math.ceil(pagination.totalRecords / pagination.limit)
    ) {
      setPagination((prev) => ({
        ...prev,
        page: newPage,
      }));
    }
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  const start = (pagination.page - 1) * pagination.limit + 1;
  const end = Math.min(
    pagination.page * pagination.limit,
    pagination.totalRecords
  );

  return (
    <div
      id="page-container"
      className="page-header-fixed page-sidebar-fixed fade in"
    >
      <div id="content" className="">
        <div className="panel panel-default with-rounded-corner with-shadow">
          <form onSubmit={handleSubmit} className="stdform">
            <input type="hidden" name="subscriberid" value="" />
            <div className="panel-heading">
              <span className="panel-title">Manage Sent WhatsApp Bulk</span>
            </div>
            <div className="panel-body">
              <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                    <label className="control-label">
                      Select WhatsApp Template
                    </label>
                    <select
                      name="templateid"
                      className="form-control"
                      value={formData.templateid}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">-- Select Template --</option>
                      {templateList.map((template) => (
                        <option key={template.id} value={template.id}>
                          {template.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-group">
                    <label className="control-label">Select Lead Source</label>
                    <select
                      name="leadsource"
                      className="form-control"
                      value={formData.leadsource}
                      onChange={handleInputChange}
                    >
                      <option value="">-- Select Lead Source --</option>
                      {leadSourceList.map((source) => (
                        <option key={source.id} value={source.id}>
                          {source.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-group">
                    <label className="control-label">Select Lead Status</label>
                    <select
                      name="leadstatus"
                      className="form-control"
                      value={formData.leadstatus}
                      onChange={handleInputChange}
                    >
                      <option value="">-- Select Lead Status --</option>
                      {leadStatusList.map((status) => (
                        <option key={status.id} value={status.id}>
                          {status.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="col-md-8">
                  <div className="row">
                    <div className="col-md-2">
                      <div className="form-group">
                        <label className="control-label">Date Range</label>
                        <DatePicker
                          selectsRange={true}
                          startDate={startDate}
                          endDate={endDate}
                          onChange={handleDateChange}
                          className="form-control"
                          placeholderText="Select date range"
                          dateFormat="dd-MM-yyyy"
                          isClearable={true}
                          monthsShown={2}
                        />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group" style={{ marginTop: "25px" }}>
                        <button
                          type="submit"
                          name="submit"
                          className="btn btn-primary"
                          style={{ width: "100%" }}
                          disabled={submitLoading}
                        >
                          {submitLoading ? (
                            <>
                              {/* <i className="fa fa-spinner fa-spin me-2"></i> */}
                              Sending...
                            </>
                          ) : (
                            "Submit"
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div className="panel panel-default with-rounded-corner with-shadow p-10">
          {pagination.totalRecords > pagination.limit && (
            <div className="d-flex align-items-center float-end mb-2">
              <span style={{ fontSize: "0.85rem" }}>
                {start} to {end} of {pagination.totalRecords}
              </span>
              <div>
                <button
                  className="btn btn-default btn-sm ms-2"
                  title="Previous"
                  onClick={() => handlePageChange(pagination.page - 1)}
                  disabled={pagination.page === 1}
                >
                  <FontAwesomeIcon icon={faChevronLeft} />
                </button>
                &nbsp;
                <button
                  className="btn btn-default btn-sm"
                  title="Next"
                  onClick={() => handlePageChange(pagination.page + 1)}
                  disabled={
                    pagination.page >=
                    Math.ceil(pagination.totalRecords / pagination.limit)
                  }
                >
                  <FontAwesomeIcon icon={faChevronRight} />
                </button>
              </div>
            </div>
          )}

          {/* Responsive table wrapper */}
          <div className="table-responsive">
            <table className="table table-condensed table-bordered bg-white">
              <thead>
                <tr>
                  <th style={{ textAlign: "center" }}>#</th>
                  <th>Template</th>
                  <th>Criteria</th>
                </tr>
              </thead>
              <tbody>
                {sendWhatsapp.length > 0 ? (
                  sendWhatsapp.map((post, index) => (
                    <tr key={index}>
                      <td
                        style={{ textAlign: "center", verticalAlign: "middle" }}
                      >
                        {(pagination.page - 1) * pagination.limit + index + 1}
                      </td>
                      <td>{post.t2_templatename || "N/A"}</td>
                      <td>
                        <div className="criteria-content">
                          {parseSendToCriteria(post.sendto)}
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="3"
                      style={{ textAlign: "center", padding: "10px" }}
                    >
                      No WhatsApp messages sent yet
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        <input type="hidden" name="delid" id="delid" value="0" />

        {/* Add custom CSS for better mobile responsiveness */}
        <style>{`
          @media (max-width: 768px) {
            .table-responsive {
              border: 1px solid #dee2e6;
              border-radius: 4px;
              overflow-x: auto;
              -webkit-overflow-scrolling: touch;
            }
            
            .table {
              min-width: 600px;
              margin-bottom: 0;
            }
            
            .criteria-content {
              word-break: break-word;
              max-width: 300px;
            }
            
            .panel.p-10 {
              padding: 10px !important;
            }
            
            .table-condensed > thead > tr > th,
            .table-condensed > tbody > tr > td {
              padding: 8px 5px;
            }
            
            /* Ensure pagination is visible on mobile */
            .float-end {
              float: none !important;
              justify-content: center !important;
              width: 100%;
            }
            
            .d-flex.align-items-center.float-end {
              flex-direction: column;
              gap: 10px;
              margin-bottom: 15px !important;
            }
            
            .d-flex.align-items-center.float-end > span {
              order: 2;
            }
            
            .d-flex.align-items-center.float-end > div {
              order: 1;
            }
          }
          
          @media (max-width: 576px) {
            .table {
              min-width: 500px;
            }
            
            .criteria-content {
              max-width: 200px;
            }
            
            .panel-body .row > div[class*="col-"] {
              margin-bottom: 15px;
            }
            
            .panel-body .row > div[class*="col-"]:last-child {
              margin-bottom: 0;
            }
          }
        `}</style>

        <a href="#" data-click="scroll-top" className="btn-scroll-top fade">
          <i className="ti-arrow-up"></i>
        </a>
      </div>
    </div>
  );
};

export default SendWhatsappBulk;